import api from '@api/endpoints';

/**
 * Validate form data
 */
export const validateFormData = (formData, fromSidebar) => {
  // Validate source
  if (!formData.sourceClient || !formData.sourceSubClient || !formData.sourceCurrency) {
    return {
      isValid: false,
      error: 'Please select source client, subclient, and currency.'
    };
  }

  // Validate destination when not from sidebar
  if (!fromSidebar) {
    if (!formData.destinationClient || !formData.destinationSubClient || !formData.destinationCurrency) {
      return {
        isValid: false,
        error: 'Please select destination client, subclient, and currency.'
      };
    }
  }

  return { isValid: true };
};

/**
 * Submit copy configuration request
 */
export const submitCopyConfig = async (payload) => {
  return await api.falconDashboard.copyPayoutConfig(payload);
};

/**
 * Get destination display text
 */
export const getDestinationDisplay = (formData, fromSidebar, entity, subClientName) => {
  return fromSidebar 
    ? `${entity?.name?.value} (${subClientName})`
    : `${formData.destinationClient} (${formData.destinationSubClient})`;
};

